import React from 'react';
import { useReveal, useCounter } from '../hooks/useReveal';
import { useLanguage } from '../hooks/useLanguage';
import { content } from '../data/content';
import { Eyebrow } from './ui/Section';

const StatCell = ({ stat, idx, when }) => {
  const decimals = Number.isInteger(stat.value) ? 0 : 1;
  const v = useCounter(stat.value, { duration: 1500, decimals, when });
  return (
    <div className="px-4 py-5 sm:px-6 sm:py-8 relative">
      <span className="text-mono text-[0.65rem] uppercase tracking-[0.22em] text-subtle">
        {String(idx + 1).padStart(2, '0')}
      </span>
      <div className="mt-3 flex items-baseline gap-1">
        <span className="text-display text-3xl sm:text-5xl md:text-6xl font-bold text-app tabular-nums">
          {decimals > 0 ? v.toFixed(1) : v}
        </span>
        <span className="text-display text-3xl font-bold text-muted">{stat.suffix}</span>
      </div>
      <p className="mt-3 text-sm font-medium text-app">{stat.label}</p>
      <p className="mt-1 text-xs text-muted">{stat.hint}</p>
    </div>
  );
};

export const Stats = () => {
  const { language } = useLanguage();
  const t = content[language];
  const [ref, inView] = useReveal();

  return (
    <section className="py-14 sm:py-20 md:py-28 bg-app">
      <div className="container">
        <div className="max-w-2xl mx-auto text-center mb-10">
          <Eyebrow label={t.stats.eyebrow} />
          <h2 className="mt-4 text-display font-bold text-display-lg text-app">{t.stats.title}</h2>
        </div>
        <div
          ref={ref}
          className="rounded-3xl border overflow-hidden bg-surface shadow-soft grid grid-cols-2 lg:grid-cols-4 divide-y lg:divide-y-0 lg:divide-x"
          style={{ borderColor: 'var(--border)', '--tw-divide-opacity': 1 }}
        >
          {t.stats.items.map((s, i) => (
            <div
              key={s.label}
              className="[&:nth-child(2)]:border-l lg:[&:nth-child(2)]:border-l-0"
              style={{ borderColor: 'var(--border)' }}
            >
              <StatCell stat={s} idx={i} when={inView} />
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Stats;
